/* eslint-disable */
import React from 'react'
import styled, { css } from 'styled-components';
import { Checkbox as AntdCheckbox } from 'antd'

const StyledCheckbox = styled(AntdCheckbox)`
  padding-top: 5px;

  .ant-checkbox + span {
    padding-left: 12px;
  }
`
const LabelWrapper = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  padding-bottom: 8px;
  cursor:pointer;

  ${(props) =>
    props.isAdded === false &&
    css`
      color: #343E59;
    `}
`;

const Checkbox = ({ onChange, label, value,isAdded, ...rest }) => {
  return (
    <StyledCheckbox {...rest} onChange={onChange} value={value}>
      <LabelWrapper isAdded={isAdded}>{label}</LabelWrapper>

    </StyledCheckbox>
  )
}
export default Checkbox
